import { NO_WRAP } from "./../ricos-content/index.js";
const ALIGN_CENTER = "center";
const SIZE_LARGE = "large";
const DEFAULTS = Object.freeze({
  type: "single",
  config: {
    size: SIZE_LARGE,
    alignment: ALIGN_CENTER,
    textWrap: NO_WRAP
  }
});
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
